module.exports = __webpack_public_path__ + "static/media/angle-right.9e2dcb83.svg";